import { EmoticonKissOutlineIcon } from './EmoticonKissOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 806569AC-841D-4B4E-849E-43BACC3D2268
 * name emoticon-kiss-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-kiss-outline.svg
 * tags
 * - Emoji 
 */
export const FaceKissOutlineIcon = EmoticonKissOutlineIcon;
export default FaceKissOutlineIcon